import {
  LEGAL_ENTITY_SUCCESS,
  LEGAL_ENTITY_FAILED,
  RESET_LEGAL_ENTITY,
  LOADING_LEGAL_ENTITY,
  NETWORK_ERROR_LEGAL_ENTITY,
} from "../types/index";
const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_LEGAL_ENTITY:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
      };
    case LEGAL_ENTITY_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
      };
    case LEGAL_ENTITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
      };
    case NETWORK_ERROR_LEGAL_ENTITY:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
      };
    case RESET_LEGAL_ENTITY:
      return (state = initialState);
    default:
      return state;
  }
};
